module.exports = __webpack_public_path__ + "img/persona1.490f7ff0.png";